import React from 'react';
import _ from 'lodash';
import { useRecoilValue } from 'recoil';
import { faFile, faFileAlt, faSchool, faUniversity, faUsers } from '@fortawesome/pro-duotone-svg-icons';
import { useTranslation } from 'react-i18next';
import MainPage from '../../shared-components/main-page/MainPage';
import HomeCard from './shared-components/HomeCard';
import { userPrivilagesAtom, userOrganizationsAtom } from '../../../atoms/Atoms';

function AdminHome() {
  const { t } = useTranslation();
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const userOrganizations = useRecoilValue(userOrganizationsAtom);
  return (
    <MainPage requiresCloser>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {userPrivilages?.hasCustomerSupportPrivilages && (
          <HomeCard
            icon={faUsers}
            title={t('users')}
            description={t('users_desc')}
            route="/admin/users"
          />
        )}
        {userPrivilages?.hasCloserAdminPrivilages && (
          <>
            <HomeCard
              icon={faUniversity}
              title={t('organizations')}
              description={t('organizations_desc')}
              route="/admin/organizations"
            />
            <HomeCard
              icon={faFile}
              title={t('requests')}
              description={t('requests_desc')}
              route="/admin/requests"
            />
          </>
        )}
        {userPrivilages?.hasCustomerSupportPrivilages && (
          <HomeCard
            icon={faFileAlt}
            title={t('admin_leads')}
            description={t('leads_desc')}
            route="/admin/leads"
          />
        )}
        {userPrivilages?.hasLearningManager && (
          <HomeCard
            icon={faSchool}
            title={t('learning_center')}
            description={t('learning_center_management_desc')}
            route="/admin/learning"
          />
        )}
        {userPrivilages?.hasCloserAdminPrivilages && _.map(userOrganizations, (org) => (
          <HomeCard
            icon={faFileAlt}
            title={`${org.nameEn}`}
            description={`${t('org_leads_desc')} ${org.nameEn}`}
            route={`/admin/leads/${org.referralCode}`}
          />
        ))}
        {/* <HomeCard
          icon={faUniversity}
          title={t('deals')}
          description={t('deals_desc')}
          route="/admin/deals"
        /> */}
      </div>
    </MainPage>
  );
}

export default AdminHome;
